import { useState, useEffect } from "react";

const offers = [
  "Get up to 10% OFF on Prepaid — Limited Time Offer!",
  "Get up to 10% OFF on Prepaid — Limited Time Offer!",
  "Get up to 10% OFF on Prepaid — Limited Time Offer!",
  "Get up to 10% OFF on Prepaid — Limited Time Offer!",
];

const style = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;600&display=swap');

  .marquee-root {
    width: 100%;
    overflow: hidden;
    background: #1a2e1a;
    background-image: repeating-linear-gradient(
      45deg,
      rgba(255,255,255,0.015) 0px,
      rgba(255,255,255,0.015) 1px,
      transparent 1px,
      transparent 8px
    );
    border-bottom: 1px solid rgba(255,255,255,0.08);
    padding: 9px 0;
    font-family: 'DM Sans', sans-serif;
    box-sizing: border-box;
  }

  .marquee-track {
    display: flex;
    width: max-content;
    animation: marquee-scroll 59s linear infinite;
    will-change: transform;
  }

  .marquee-track:hover {
    animation-play-state: paused;
  }

  .marquee-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 48px;
    white-space: nowrap;
    font-size: clamp(11px, 2.2vw, 13.5px);
    font-weight: 600;
    letter-spacing: 0.03em;
    color: #e8f0e8;
    text-transform: none;
    user-select: none;
  }

  .marquee-flame {
    font-size: clamp(13px, 2.5vw, 16px);
    line-height: 1;
    animation: flame-pulse 1.6s ease-in-out infinite alternate;
    display: inline-block;
  }

  .marquee-dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: rgba(255,255,255,0.25);
    flex-shrink: 0;
  }

  @keyframes marquee-scroll {
    0%   { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  @keyframes flame-pulse {
    0%   { transform: scale(1) translateY(0px); filter: brightness(1); }
    100% { transform: scale(1.18) translateY(-1px); filter: brightness(1.3); }
  }

  @media (max-width: 480px) {
    .marquee-root {
      padding: 7px 0;
    }
    .marquee-item {
      padding: 10px 32px;
    }
  }
`;

export default function MarqueeBanner() {
  
  const items = [...offers, ...offers, ...offers, ...offers];

  return (
    <>
      <style>{style}</style>
      <div className="marquee-root" aria-label="Promotional offers ticker">
        <div className="marquee-track">
          {items.map((text, i) => (
            <span className="marquee-item" key={i}>
              {text}
              <span className="marquee-flame" aria-hidden="true">🔥</span>
              {i < items.length - 1 && <span className="marquee-dot" aria-hidden="true" />}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}